import API from "../../services/api.svelte.js";
import { CVSS } from "@turingpointde/cvss.js";
import { get as getStore } from "svelte/store";
import { locale, format } from "svelte-i18n";




const KB_URL = "https://gitlab.com/securetia/vulseek/kb/-/tree/master/vulnerability";

// store vulnerabilitiesPromise to avoid multiple simultaneous API calls
let vulnerabilitiesPromise;
let vulnerabilities = [];
let updated_at = null;

const kinds = [
    { label: "AD (Active Directory)", id: "AD" },
    { label: "ASVS (OWASP Application Security Verification Standard)", id: "ASVS" },
    { label: "CVE (Common Vulnerabilities and Exposures)", id: "CVE" },
    { label: "INFO (Información)", id: "INFO" },
    { label: "LEAK (Filtración de Datos)", id: "LEAK" },
    { label: "NVT (OpenVAS Network Vulnerability Test)", id: "NVT" },
    { label: "SVE (Securetia)", id: "SVE" },
    { label: "EOL (Fuera de soporte)", id: "EOL" },
    { label: "DMARC", id: "DMARC" },
    { label: "SPF", id: "SPF" },
    { label: "M365 (Microsoft 365)", id: "M365" },
    { label: "CODE (Análisis de código fuente)", id: "CODE" },
    { label: "Privada", id: "X-" }
];

function setLocale() {
    let setLocale = getStore(locale);
    if (setLocale != "es" && setLocale != "en") setLocale = 'es';
    locale.set(setLocale);
}

function setIDasFallback(vuls) {
    if (Array.isArray(vuls)) {
        for (let vul of vuls) {
            if (!vul.title) {
                vul.title = vul.id;
            }
            if (!vul.title_es) {
                vul.title_es = vul.title || vul.id;
            }
        }
    }
    return vuls;
}

export function search(resource, config = { filter: null }) {
    vulnerabilitiesPromise = API.search(resource, config)
        .catch(() => {
            return [];
        })
        .then(pVuls => {
            vulnerabilities = setIDasFallback(pVuls);
            return vulnerabilities;
        })
        ;
    return vulnerabilitiesPromise;
}

export function searchFiltered(config = { filter: null }) {

    let filteredVulsPromise = API.search("v2/vulnerability/", config)
        .catch(() => {
            return [];
        })
        .then(pVuls => {
            let vuls = setIDasFallback(pVuls);
            return vuls;
        })
        ;
    return filteredVulsPromise;
}


export function forceSearch(config = { filter: null }) {
    let noCacheVulsPromise = API.search("v2/vulnerability/", config)
        .catch(() => {
            return [];
        })
        .then(pVuls => {
            let vuls = setIDasFallback(pVuls);
            return vuls;
        })
        ;
    return noCacheVulsPromise;
}

export function updateCache(vulnerability, should_add) {
    if (vulnerabilities.length > 0) {
        if (should_add) {
            vulnerabilities.push(vulnerability);
        }
        else {
            vulnerabilities.filter(vul => vul.id != vulnerability.id);
        }
    }
}

export function searchProps(config = { filter: null }) {
    let propsPromise = API.search("v2/vulnerability-property/", config)
        .catch(() => {
            return [];
        })
        .then(pProps => {
            let props = pProps;
            return props;
        })
        ;
    return propsPromise;
}

export async function find(resource, id, config = {}) {
    let vulnerability = await API.find(resource, id, config);
    //lazy way of reutilizing buildCVEtitles func for one vul only
    if (vulnerability.id.includes("CVE-")) vulnerability = (await buildCVEtitles([vulnerability]))[0];
    return vulnerability;
}

export async function getNote(id, config = {}) {
    let note = await API.search("v2/vulnerability/" + id + "/note", config);
    return note;
}

export async function upsertNote(vul_id, data, config = {}) {
    let resource = "v2/vulnerability/" + vul_id + "/note";
    let note = await API.upsert(resource, data, [], config);
    return note;
}

export async function deleteNote(vul_id, config = {}) {
    let resource = "v2/vulnerability/" + vul_id + "/note";
    await API.del(resource, "", config)
        .then(response => {
            if (response.ok) {
                return "Ok"
            }
            else {
                return false;
            }
        })
        ;
}

export async function buildCVEtitles(vulnerabilities = []) {
    for (let vulnerability of vulnerabilities) {
        if (vulnerability.id.includes("CVE-")) {
            if (!vulnerability.title) {
                vulnerability.title = vulnerability.id;
            }
            else if (!vulnerability.title_es) {
                vulnerability.title_es = vulnerability.title
            }
            else {
                vulnerability.title = `${vulnerability.title} (${vulnerability.id})`
                vulnerability.title_es = `${vulnerability.title_es} (${vulnerability.id})`
            }
        }
    }
    return vulnerabilities;
}

/**
 * Parse score value
 * Return name
 * @param float score
 * @return string
 */
export function scoreName(score) {
    /*if (score == 0.0) {
        return "good";
    }

    if (score < 1.0) {
        return "info";
    }*/

    if (score < 4 || score == "low") {
        return "low";
    }

    if (score < 7 || score == "medium") {
        return "medium";
    }

    if (score < 9 || score == "high") {
        return "high";
    }

    return "critical";
};

export const labels = {
    //good     : "Buena",
    info: "Info",
    //none     : "Ninguna",
    low: "Baja",
    medium: "Media",
    high: "Alta",
    critical: "Crítica",
};

export function attackVectorOrder(attack_vector) {
    return {
        network: 0,
        adjacent: 1,
        local: 2,
        physical: 3,
    }[attack_vector];
}

export function buildCVSSvector(data = {}) {
    let vector = {
        CVSS: "3.1",
        AV: data.AV,
        AC: data.AC,
        PR: data.PR,
        UI: data.UI,
        S: data.S,
        C: data.C,
        I: data.I,
        A: data.A,
    };
    return CVSS(vector).vector;
}

export function parseCVSSvector(vulnerability, version) {

    let cvss_data_spanish = {};
    let metrics;
    if (vulnerability.cvss4_vector && version == 4) {
        const vectorV4 = CVSS(vulnerability.cvss4_vector);
        metrics = vectorV4.getDetailedVectorObject().metrics;
        Object.entries(metrics).forEach(([name, obj]) => cvss_data_spanish[name] = getCVSS_v4_vectorValues(name, metrics[name].value));
    }
    else if (vulnerability.cvss3_vector && version == 3) {
        const vectorV3 = CVSS(vulnerability.cvss3_vector);
        metrics = vectorV3.getDetailedVectorObject().metrics;
        Object.entries(metrics).forEach(([name, obj]) => cvss_data_spanish[name] = getCVSS_v3_vectorValues(name, metrics[name].value));
    }

    else if (vulnerability.cvss2_vector && version == 2) {
        const vectorV2 = vulnerability.cvss2_vector;
        metrics = parseCVSS2(vectorV2);
        Object.entries(metrics).forEach(([name, obj]) => cvss_data_spanish[name] = getCVSS_v2_vectorValues(name, metrics[name].value));

    }
    else {
        return;
    }


    return cvss_data_spanish;
}


export function getCVSS_v4_vectorValues(metric, val) {

    let values = {
        AV: getCVSSv4items(val).attackVector().value,
        AC: getCVSSv4items(val).attackComplexity().value,
        AT: getCVSSv4items(val).attackRequirements().value,
        PR: getCVSSv4items(val).privilegesRequired().value,
        UI: getCVSSv4items(val).userInteraction().value,
        VC: getCVSSv4items(val).confidentialityImpactVulnerable().value,
        VI: getCVSSv4items(val).integrityImpactVulnerable().value,
        VA: getCVSSv4items(val).availabilityImpactVulnerable().value,
        SC: getCVSSv4items(val).confidentialityImpactSubsequent().value,
        SI: getCVSSv4items(val).integrityImpactSubsequent().value,
        SA: getCVSSv4items(val).availabilityImpactSubsequent().value
    }

    return values[metric] ? values[metric]["label"] : "";

}

export function getCVSS_v3_vectorValues(metric, val) {

    let values = {
        AV: getCVSSv3items(val).attackVector().value,
        AC: getCVSSv3items(val).attackComplexity().value,
        PR: getCVSSv3items(val).privilegesRequired().value,
        UI: getCVSSv3items(val).userInteraction().value,
        S: getCVSSv3items(val).scope().value,
        C: getCVSSv3items(val).confidentialityImpact().value,
        I: getCVSSv3items(val).integrityImpact().value,
        A: getCVSSv3items(val).availabilityImpact().value,
    }

    return values[metric]["label"];

}

export function getCVSS_v2_vectorValues(metric, val) {

    let values = {
        AV: getCVSSv2items(val).attackVector().value,
        AC: getCVSSv2items(val).attackComplexity().value,
        Au: getCVSSv2items(val).authentication().value,
        C: getCVSSv2items(val).confidentialityImpact().value,
        I: getCVSSv2items(val).integrityImpact().value,
        A: getCVSSv2items(val).availabilityImpact().value,
    }

    return values[metric]["label"];

}

export function getCVSSv4items(val) {
    setLocale();
    function attackVector() {

        const labels = {
            Network: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Network"),
            Adjacent: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Adjacent"),
            Local: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Local"),
            Physical: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Physical"),
        };

        const descriptions = {
            Network: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Network"),
            Adjacent: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Adjacent"),
            Local: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Local"),
            Physical: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Physical"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function attackComplexity() {
        const labels = {
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.AC.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.AC.High"),
        };

        const descriptions = {
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.AC.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.AC.High"),
        };


        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function attackRequirements() {
        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.AT.None"),
            Present: getStore(format)("vulnerability.cve_data.cvss_labels.AT.Present"),
        };

        const descriptions = {
            none: getStore(format)("vulnerability.cve_data.cvss_descriptions.AT.None"),
            present: getStore(format)("vulnerability.cve_data.cvss_descriptions.AT.Present"),
        };


        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function privilegesRequired() {
        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.PR.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.PR.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.PR.High"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.PR.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.PR.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.PR.High"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function userInteraction() {
        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.UI.None"),
            Passive: getStore(format)("vulnerability.cve_data.cvss_labels.UI.Passive"),
            Active: getStore(format)("vulnerability.cve_data.cvss_labels.UI.Active"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.UI.None"),
            passive: getStore(format)("vulnerability.cve_data.cvss_descriptions.UI.Passive"),
            active: getStore(format)("vulnerability.cve_data.cvss_descriptions.UI.Active"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function confidentialityImpactVulnerable() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.VC.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.VC.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.VC.High"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.VC.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.VC.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.VC.High")
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }


    function integrityImpactVulnerable() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.VI.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.VI.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.VI.High"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.VI.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.VI.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.VI.High"),

        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function availabilityImpactVulnerable() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.VA.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.VA.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.VA.High"),
        };
        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.VA.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.VA.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.VA.High"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function confidentialityImpactSubsequent() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.SC.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.SC.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.SC.High"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.SC.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.SC.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.SC.High"),

        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }


    function integrityImpactSubsequent() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.SI.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.SI.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.SI.High"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.SI.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.SI.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.SI.High"),

        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function availabilityImpactSubsequent() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.SA.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.SA.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.SA.High"),
        };
        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.SA.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.SA.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.SA.High"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    return {
        attackVector: attackVector,
        attackComplexity: attackComplexity,
        privilegesRequired: privilegesRequired,
        userInteraction: userInteraction,
        attackRequirements: attackRequirements,
        confidentialityImpactVulnerable: confidentialityImpactVulnerable,
        integrityImpactVulnerable: integrityImpactVulnerable,
        availabilityImpactVulnerable: availabilityImpactVulnerable,
        confidentialityImpactSubsequent: confidentialityImpactSubsequent,
        integrityImpactSubsequent: integrityImpactSubsequent,
        availabilityImpactSubsequent: availabilityImpactSubsequent
    }
}

export function getCVSSv3items(val) {
    setLocale();
    function attackVector() {

        const labels = {
            Network: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Network"),
            Adjacent: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Adjacent"),
            Local: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Local"),
            Physical: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Physical"),
        };

        const descriptions = {
            Network: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Network"),
            Adjacent: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Adjacent"),
            Local: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Local"),
            Physical: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Physical"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function attackComplexity() {
        const labels = {
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.AC.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.AC.High"),
        };

        const descriptions = {
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.AC.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.AC.High"),
        };


        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function privilegesRequired() {
        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.PR.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.PR.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.PR.High"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.PR.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.PR.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.PR.High"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function userInteraction() {
        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.UI.None"),
            Required: getStore(format)("vulnerability.cve_data.cvss_labels.UI.Required"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.UI.None"),
            Required: getStore(format)("vulnerability.cve_data.cvss_descriptions.UI.Required"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function scope() {

        const labels = {
            Unchanged: getStore(format)("vulnerability.cve_data.cvss_labels.scope.Unchanged"),
            Changed: getStore(format)("vulnerability.cve_data.cvss_labels.scope.Changed")
        };

        const descriptions = {
            Unchanged: getStore(format)("vulnerability.cve_data.cvss_descriptions.scope.Unchanged"),
            Changed: getStore(format)("vulnerability.cve_data.cvss_descriptions.scope.Changed")
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function confidentialityImpact() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.C.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.C.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.C.High"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.C.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.C.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.C.High"),

        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function integrityImpact() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.I.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.I.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.I.High"),
        };

        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.I.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.I.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.I.High"),

        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function availabilityImpact() {

        const labels = {
            None: getStore(format)("vulnerability.cve_data.cvss_labels.A.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_labels.A.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_labels.A.High"),
        };
        const descriptions = {
            None: getStore(format)("vulnerability.cve_data.cvss_descriptions.A.None"),
            Low: getStore(format)("vulnerability.cve_data.cvss_descriptions.A.Low"),
            High: getStore(format)("vulnerability.cve_data.cvss_descriptions.A.High")
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    return {
        attackVector: attackVector,
        attackComplexity: attackComplexity,
        privilegesRequired: privilegesRequired,
        userInteraction: userInteraction,
        scope: scope,
        confidentialityImpact: confidentialityImpact,
        integrityImpact: integrityImpact,
        availabilityImpact: availabilityImpact
    }
}

export function getCVSSv2items(val) {
    setLocale();
    function attackVector() {

        const labels = {
            N: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Network"),
            A: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Adjacent"),
            L: getStore(format)("vulnerability.cve_data.cvss_labels.AV.Local"),
        };

        const descriptions = {
            N: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Network"),
            A: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Adjacent"),
            L: getStore(format)("vulnerability.cve_data.cvss_descriptions.AV.Local"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function attackComplexity() {
        const labels = {
            L: getStore(format)("vulnerability.cve_data.cvss_labels.AC.Low"),
            M: getStore(format)("vulnerability.cve_data.cvss_labels.AC.Medium"),
            H: getStore(format)("vulnerability.cve_data.cvss_labels.AC.High"),
        };

        const descriptions = {
            L: getStore(format)("vulnerability.cve_data.cvss_descriptions.AC.Low"),
            M: getStore(format)("vulnerability.cve_data.cvss_descriptions.AC.Medium"),
            H: getStore(format)("vulnerability.cve_data.cvss_descriptions.AC.High"),
        };


        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function confidentialityImpact() {

        const labels = {
            N: getStore(format)("vulnerability.cve_data.cvss_labels.C.None"),
            P: getStore(format)("vulnerability.cve_data.cvss_labels.C.Partial"),
            C: getStore(format)("vulnerability.cve_data.cvss_labels.C.Complete"),
        };

        const descriptions = {
            N: getStore(format)("vulnerability.cve_data.cvss_descriptions.C.None"),
            P: getStore(format)("vulnerability.cve_data.cvss_descriptions.C.Partial"),
            C: getStore(format)("vulnerability.cve_data.cvss_descriptions.C.Complete"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }


    function integrityImpact() {

        const labels = {
            N: getStore(format)("vulnerability.cve_data.cvss_labels.I.None"),
            P: getStore(format)("vulnerability.cve_data.cvss_labels.I.Partial"),
            C: getStore(format)("vulnerability.cve_data.cvss_labels.I.Complete"),
        };

        const descriptions = {
            N: getStore(format)("vulnerability.cve_data.cvss_descriptions.I.None"),
            P: getStore(format)("vulnerability.cve_data.cvss_descriptions.I.Partial"),
            C: getStore(format)("vulnerability.cve_data.cvss_descriptions.I.Complete")
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function availabilityImpact() {

        const labels = {
            N: getStore(format)("vulnerability.cve_data.cvss_labels.A.None"),
            P: getStore(format)("vulnerability.cve_data.cvss_labels.A.Partial"),
            C: getStore(format)("vulnerability.cve_data.cvss_labels.A.Complete"),
        };
        const descriptions = {
            N: getStore(format)("vulnerability.cve_data.cvss_descriptions.A.None"),
            P: getStore(format)("vulnerability.cve_data.cvss_descriptions.A.Partial"),
            C: getStore(format)("vulnerability.cve_data.cvss_descriptions.A.Complete"),
        };

        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    function authentication() {
        const labels = {
            N: getStore(format)("vulnerability.cve_data.cvss_labels.Au.N"),
            S: getStore(format)("vulnerability.cve_data.cvss_labels.Au.S"),
            M: getStore(format)("vulnerability.cve_data.cvss_labels.Au.M"),
        };
        const descriptions = {
            N: getStore(format)("vulnerability.cve_data.cvss_descriptions.Au.N"),
            S: getStore(format)("vulnerability.cve_data.cvss_descriptions.Au.S"),
            M: getStore(format)("vulnerability.cve_data.cvss_descriptions.Au.M"),
        };
        return {
            items: getCVSSobject(labels, descriptions),
            value: {
                label: labels[val],
                description: descriptions[val]
            }
        }
    }

    return {
        attackVector: attackVector,
        attackComplexity: attackComplexity,
        authentication: authentication,
        confidentialityImpact: confidentialityImpact,
        integrityImpact: integrityImpact,
        availabilityImpact: availabilityImpact
    }
}

export function getCVSSobject(labels, descriptions) {

    let items = [];
    Object.keys(labels).forEach(k => {
        items.push({
            label: labels[k],
            description: descriptions[k],

        });
    });

    return items;
}


export function parseCVSS2(cvss_vector) {
    let cvss_vector_attackVector = cvss_vector.split("AC:")[0].split("AV:")[1].split("/")[0];
    let cvss_vector_complexity = cvss_vector.split("Au:")[0].split("AC:")[1].split("/")[0];
    let cvss_vector_auth = cvss_vector.split("/C:")[0].split("Au:")[1].split("/")[0];
    let cvss_vector_confidentiality = cvss_vector.split("I:")[0].split("/C:")[1].split("/")[0];;
    let cvss_vector_integrity = cvss_vector.split("A:")[0].split("I:")[1].split("/")[0];;
    let cvss_vector_availability = cvss_vector.split("A:")[1];

    return {
        "AV": { value: cvss_vector_attackVector },
        "AC": { value: cvss_vector_complexity },
        "Au": { value: cvss_vector_auth },
        "C": { value: cvss_vector_confidentiality },
        "I": { value: cvss_vector_integrity },
        "A": { value: cvss_vector_availability },
    }
}

export function getDecimalPart(value) {
    return value % 1.0;
};


export default {
    kinds,
    kb_url: KB_URL,
    search,
    searchFiltered,
    forceSearch,
    updateCache,
    searchProps,
    find,
    getNote,
    upsertNote,
    deleteNote,
    buildCVEtitles,
    labels,
    scoreName,
    buildCVSSvector,
    attackVectorOrder,
    parseCVSS2,
    parseCVSSvector,
    getCVSS_v2_vectorValues,
    getCVSS_v3_vectorValues,
    getCVSSv3items,
    getDecimalPart
}
